import type { ApiRoute, NoBody, NoQueryParams } from "../api"

export interface GenerateQrCodeQueryParams {
	url: string
}

export interface QRCodeResponse {
	dataUrl: string
}

export const generateQrCodeRoute: ApiRoute<NoQueryParams, GenerateQrCodeQueryParams, NoBody, QRCodeResponse> = {
	buildUrl: () => "/generateQrCode",
	method: "post",
	path: "/generateQrCode",
}
